
// Utilities for i18n module
import { supabase } from '@/integrations/supabase/client';
import { defaultResources } from './defaultResources';

/**
 * Converts database translations to i18next resource format
 */
export const convertDbTranslationsToResources = (dbTranslations: any[]) => {
  const resources: Record<string, any> = {};
  
  if (!dbTranslations || dbTranslations.length === 0) {
    return defaultResources;
  }
  
  dbTranslations.forEach(({ locale, key, value }) => {
    if (!resources[locale]) {
      resources[locale] = { common: {} };
    }
    
    const parts = key.split('.');
    let current = resources[locale].common;
    
    for (let i = 0; i < parts.length - 1; i++) {
      if (!current[parts[i]]) {
        current[parts[i]] = {};
      }
      current = current[parts[i]];
    }
    
    current[parts[parts.length - 1]] = value;
  });
  
  return resources;
};

/**
 * Loads translations from database
 */
export const loadTranslationsFromDb = async () => {
  try {
    const { data, error } = await supabase.rpc('get_all_translations');
    
    if (error) {
      console.error("Error loading translations from database:", error);
      return null;
    }
    
    if (!data || data.length === 0) {
      console.log("No translations found in database, using default resources");
      return null;
    }
    
    console.log("Loaded translations from database:", data.length);
    return convertDbTranslationsToResources(data);
  } catch (error) {
    console.error("Exception loading translations from database:", error);
    return null;
  }
};

/**
 * Loads translations from local storage
 */
export const loadTranslationsFromStorage = () => {
  try {
    const savedResources = localStorage.getItem('i18nextResources');
    if (savedResources) {
      return JSON.parse(savedResources);
    }
  } catch (error) {
    console.error("Error loading saved translations:", error);
  }
  return null;
};
